import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom } from 'rxjs';
import { AuthService } from 'src/app/shared/auth/services/auth.service';
import { UserLoginSed } from 'src/app/shared/models/sed/UserLogin';
import { ConvivaErrorHandlingService } from 'src/app/shared/services/convivaErrorHandlingService';
import { PsicologoService } from 'src/app/shared/services/psicologo.service';

@Component({
    selector: 'app-modal-autorizacao',
    templateUrl: './modal-autorizacao.component.html',
    styleUrls: ['./modal-autorizacao.component.scss'],
    standalone: true,
    imports:[CommonModule]
})
// export class ModalAutorizacaoComponent {
export class ModalAutorizacaoComponent implements OnInit {
  @Input() userLogado:UserLoginSed | null;

  spinner = inject(NgxSpinnerService);
  toastr = inject(ToastrService);
  authService = inject(AuthService);
  psicologoService = inject(PsicologoService);
  ConvivaErroHandler = inject(ConvivaErrorHandlingService);

  showModal: boolean = false;
  tituloModalAutorizacao = '⚠️ Autorização para Uso de Dados';
  //subtituloModalAutorizacao = 'Caro(a) Psicólogo(a), Para registrar o início da sua atividade, é necessário que você autorize a utilização dos seus dados pessoais. Esses dados serão utilizados exclusivamente para fins de registro de suas atividades no sistema, garantindo a integridade das informações e o cumprimento de nossas obrigações legais e administrativas. Informações coletadas ( Nome, CPF, CRP, Data e horário de registro, Informações da escola vinculada (CIE e nome)). O tratamento dos seus dados será realizado de acordo com a Lei Geral de Proteção de Dados (LGPD), garantindo a segurança, confidencialidade e uso adequado das informações.';

  constructor() { }

  ngOnInit(): void {
    // Exibe o modal após 10 segundos
    setTimeout(() => {
      this.showModal = true;
    }, 10000);
  }

  closeModal(): void {
    this.showModal = false;
  }

  async onClick(authorize:number) {
    this.spinner.show();
    var body = {
      status: authorize,
      cpf:this.userLogado?.cpf,
      codigoUsuario:0
    };

    const response =  await lastValueFrom(this.psicologoService.setAutorizacaoUsoDados(body))
      .catch(err => this.ConvivaErroHandler.handleResultError(err) );

    if(!response.isSucess){
      this.toastr.error('Erro ao autorizar uso de dados!');
      this.spinner.hide();
      return;
    }
    if(authorize == 1){
      this.toastr.success('Usuário autorizado!');
    }else{
      this.toastr.warning('Usuário não autorizou o uso das informações!');
    }
    this.userLogado!.autorizacaoUsoDados = authorize;
    this.authService.setUser(this.userLogado!);

    this.closeModal();
    this.spinner.hide();
  }


}
